import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';

const SIGNAL_URL = 'https://turn.lepb.fr:3004';

export default function LiveCams() {
  const [rooms, setRooms] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [titre, setTitre] = useState('');
  const [description, setDescription] = useState('');
  const [connected, setConnected] = useState(false);
  const socketRef = useRef(null);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const pseudo = user?.username || user?.email?.split('@')[0] || 'Anonyme';

  useEffect(() => {
    const socket = io(SIGNAL_URL, { transports: ['websocket'] });
    socketRef.current = socket;
    socket.on('connect', () => { setConnected(true); socket.emit('get-rooms'); });
    socket.on('disconnect', () => setConnected(false));
    socket.on('rooms-updated', (data) => { setRooms([...data]); });
    return () => socket.disconnect();
  }, []);

  const lancerLive = () => {
    if (!titre.trim()) return;
    if (!user) { navigate('/connexion'); return; }
    const roomId = `room_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;
    socketRef.current.emit('create-room', { roomId, titre, pseudo });
    navigate(`/live/${roomId}?host=1&titre=${encodeURIComponent(titre)}`);
  };

  const rejoindre = (roomId) => {
    navigate(`/live/${roomId}?host=0`);
  };

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>

      {/* HERO */}
      <div style={{ background: '#1a0808', padding: '48px 48px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20 }}>
        <div>
          <div style={{ fontSize: 12, letterSpacing: '0.2em', color: '#e8a0a0', fontWeight: 700, marginBottom: 12 }}>LIVE CAMS</div>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 30, color: '#fff', fontWeight: 400, lineHeight: 1.45, marginBottom: 10 }}>
            Les fans en direct, <em style={{ color: '#e8a0a0', fontStyle: 'italic' }}>ensemble</em>
          </h1>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.8, maxWidth: 500 }}>
            Discussions, replays commentés, hommages… Lancez votre live et partagez votre amour de Michael avec la communauté.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 10 }}>
          <button onClick={() => user ? setShowModal(true) : navigate('/connexion')}
            style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 10, padding: '13px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ff4444', display: 'inline-block' }}></span>
            Lancer mon live
          </button>
          <div style={{ fontSize: 12, color: connected ? '#2ecc71' : '#999', display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: connected ? '#2ecc71' : '#999', display: 'inline-block' }}></span>
            {connected ? 'Connecté au serveur' : 'Connexion…'}
          </div>
        </div>
      </div>

      {/* LISTE DES LIVES */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 48px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#1a1010' }}>Lives en cours</div>
          {rooms.length > 0 && (
            <div style={{ fontSize: 12, color: '#8b1a2a', fontWeight: 700, background: '#f5e8e8', padding: '3px 12px', borderRadius: 10 }}>
              {rooms.length} en direct
            </div>
          )}
        </div>

        {rooms.length === 0 ? (
          <div style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderRadius: 14, padding: '56px 32px', textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 14 }}>📡</div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#1a1010', marginBottom: 8 }}>Aucun live en ce moment</div>
            <p style={{ fontSize: 13, color: '#9a8080', lineHeight: 1.7, marginBottom: 20 }}>
              Soyez le premier à lancer un live et à inviter la communauté à vous rejoindre.
            </p>
            <button onClick={() => user ? setShowModal(true) : navigate('/connexion')}
              style={{ padding: '11px 24px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
              🔴 Lancer le premier live
            </button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
            {rooms.map(room => (
              <div key={room.id} style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #e8d5d0', overflow: 'hidden', transition: 'box-shadow 0.2s', boxShadow: '0 2px 8px rgba(139,26,42,0.05)' }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(139,26,42,0.12)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.05)'}
              >
                <div style={{ height: 130, background: '#1a0808', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {room.snapshot
                    ? <img src={room.snapshot} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                    : <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'rgba(139,26,42,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 20 }}>🎥</div>
                  }
                  <div style={{ position: 'absolute', top: 8, left: 8, background: '#ff2222', color: '#fff', fontSize: 12, fontWeight: 700, padding: '2px 8px', borderRadius: 10, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#fff', display: 'inline-block' }}></span> LIVE
                  </div>
                  <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: 12, padding: '2px 8px', borderRadius: 8 }}>
                    👁 {room.viewers}
                  </div>
                </div>
                <div style={{ padding: '14px 16px' }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1010', marginBottom: 6, lineHeight: 1.4 }}>{room.titre}</div>
                  <div style={{ fontSize: 12, color: '#6a5050', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#f5e8e8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#8b1a2a' }}>
                      {room.pseudo?.slice(0,2).toUpperCase()}
                    </div>
                    {room.pseudo}
                  </div>
                  <button onClick={() => rejoindre(room.id)}
                    style={{ width: '100%', padding: '8px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>
                    Rejoindre le live
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL CRÉER LIVE */}
      {showModal && (
        <div onClick={e => { if (e.target === e.currentTarget) setShowModal(false); }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(26,16,16,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: '36px 32px', maxWidth: 420, width: '100%', border: '1.5px solid #c49090', boxShadow: '0 20px 60px rgba(139,26,42,0.2)' }}>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#8b1a2a', marginBottom: 6 }}>Lancer mon live</div>
            <p style={{ fontSize: 13, color: '#6a5050', marginBottom: 22, lineHeight: 1.6 }}>
              Donnez un titre à votre live pour que les autres fans sachent de quoi vous allez parler.
            </p>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Titre du live *</label>
              <input value={titre} onChange={e => setTitre(e.target.value)} onKeyDown={e => e.key === 'Enter' && lancerLive()}
                placeholder="Ex : Analyse du clip Black or White"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
            </div>
            <div style={{ marginBottom: 22 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Description (optionnel)</label>
              <input value={description} onChange={e => setDescription(e.target.value)}
                placeholder="En quelques mots…"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModal(false)}
                style={{ flex: 1, padding: '11px', borderRadius: 8, border: '1.5px solid #c49090', background: '#fff', color: '#8b1a2a', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
                Annuler
              </button>
              <button onClick={lancerLive} disabled={!titre.trim()}
                style={{ flex: 2, padding: '11px', borderRadius: 8, border: 'none', background: titre.trim() ? '#8b1a2a' : '#ccc', color: '#fff', fontWeight: 700, cursor: titre.trim() ? 'pointer' : 'not-allowed', fontSize: 13 }}>
                🔴 Démarrer le live
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
